import script from "./memberBoxes.vue?vue&type=script&setup=true&lang=js"
export * from "./memberBoxes.vue?vue&type=script&setup=true&lang=js"

import "./memberBoxes.vue?vue&type=style&index=0&id=1ce810b0&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce810b0"]])

export default __exports__